module.exports = __webpack_public_path__ + "img/step@3x.c5bf3b56.png";